module.exports = require("./ebu.d.ts");